/**
 * Get the auth URL.
 * Uses SSO route (which falls back to direct BattleNet if SSO is not configured).
 * In dev mode (React dev server on any port other than 3001),
 * point directly to the backend on port 3001.
 * In production (served from backend), use relative URL.
 */
export function getAuthUrl() {
  const port = window.location.port;
  if (port && port !== '3001') {
    return 'http://localhost:3001/api/auth/sso';
  }
  return '/api/auth/sso';
}
